// extracted by mini-css-extract-plugin
module.exports = {"layout":"FixedColsLayout_layout__B0PYA","region":"FixedColsLayout_region__F6_4f"};